module.exports = __webpack_public_path__ + "img/level_four_lock.2b62136d.png";